var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintencance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#a9d0e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.69,37.94l-13.24,13.81c-.61.64-.88,1.53-.77,2.4l.45,3.31c.12.93-.17,1.85-.81,2.53l-3.17,3.38c-.49.52-1.12.85-1.82.95l-5.49.77c-.47.07-.76-.5-.44-.85l4.45-4.73c.74-.8.7-2.04-.09-2.79l-2.08-1.94c-.79-.74-2.03-.7-2.78.09l-4.45,4.74c-.32.35-.9.09-.86-.38l.41-5.52c.06-.7.35-1.37.83-1.88l3.17-3.38c.64-.68,1.55-1.03,2.47-.97l3.34.23c.88.07,1.74-.28,2.35-.91l13.24-13.81",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.81,38.99c-9.85,0-17.83,7.99-17.83,17.84s7.98,17.84,17.83,17.84,17.84-7.99,17.84-17.84",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.65,56.83h10.27v6.22l-4.44.57c-.5,1.8-1.21,3.51-2.1,5.11l2.72,3.56-8.81,8.81-3.56-2.72c-1.6.88-3.31,1.6-5.11,2.11l-.57,4.43h-12.47l-.57-4.43c-1.8-.51-3.51-1.23-5.11-2.11l-3.53,2.72-8.82-8.81,2.71-3.54c-.88-1.61-1.6-3.33-2.11-5.13l-4.42-.57v-12.46l4.43-.57c.5-1.8,1.22-3.51,2.1-5.11l-2.71-3.54,8.82-8.81,3.53,2.71c1.6-.88,3.31-1.6,5.11-2.11l.57-4.43h6.23v10.26",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintencance);
export default __webpack_public_path__ + "static/media/maintencance.7bd8c156d238de754469ba89a2a00e58.svg";
export { ForwardRef as ReactComponent };